<template>
  <tg-layout>
    <template slot="header">
      <tg-search-tool @on-submit="handleSearch">
        <tg-date-picker v-model="searchData.openDate"></tg-date-picker>
        <el-input
          :placeholder="$t('column.game_name')"
          v-model="searchData.gameName"
          class="tg-input"
          size="small"
          style="width: 240px"
          clearable
          @input="inputLimit"
        ></el-input>
      </tg-search-tool>
    </template>
    <tg-table
      ref="table"
      :columns="columns"
      :proxy="proxy"
      align="center"
      :fit="true"
      showPagination
    >
      <template slot="game_name" slot-scope="scope">
        <span
          >{{ scope.row["gameTime"] }} [{{
            scope.row["competition"]
          }}]</span
        ><br />
        <span
          ><i class="tg-icon tg-icon-grayball"></i
          >{{ scope.row["team1"] }}</span
        ><br />
        <span
          ><i class="tg-icon tg-icon-grayball"></i
          >{{ scope.row["team2"] }}</span
        ><br />
      </template>

      <template slot="tournamentBetCell" slot-scope="scope">
        <span
          :class="{ 'as-link': scope.value > 0 }"
          @click="scope.value > 0 ? showBetDetail(scope.row) : null"
          >{{ formatNumber(scope.value) }}</span
        >
      </template>
    </tg-table>
  </tg-layout>
</template>

<script>
import TgLayout from "@/layout/TgLayout";
import TgTable from "@/components/table/TgTable";
import TgSearchTool from "@/components/tool/TgSearchTool";
import TgDatePicker from "@/components/datePicker/TgDatePicker";

import date from "@/utils/date";
import apis from "@/apis";
const api = apis.game.tournament;

export default {
  components: {
    TgLayout,
    TgTable,
    TgSearchTool,
    TgDatePicker,
  },
  data() {
    return {
      columns: [],
      proxy: api.getData,
      searchData: {
        openDate: null,
        gameName: "",
      },
    };
  },
  computed: {
    request() {
      return {
        ...this.searchData,
      };
    },
  },
  created() {
    this.$store.commit("breadcrumb/clear");
    this.searchData.openDate = date.today();

    api.getColumns().then((response) => {
      this.columns = response.data;
      this.$nextTick(() => {
        this.$refs.table.init(this.request);
      });
    });
  },
  methods: {
    showBetDetail(row) {
      this.$router.push({
        name: "game.tournament-detail",
        params: {
          row: row,
        },
        title: row.name,
      });
    },
    handleSearch() {
      this.$refs.table.search(this.request);
    },
    inputLimit(val) {
      // 正则匹配非中英文及数字的字符
      let reg = /[^\u4e00-\u9fa5a-zA-Z0-9\s]/;
      // 查找是否有非中英文及数字的字符
      let n = val.search(reg);
      if (n !== -1) {
        // 截取异常字符前面的部分
        this.searchData.gameName = val.slice(0, n);
      }
    },
    formatNumber(value) {
      if (value === null || value === undefined) return "0.00";
      return Number(value)
        .toFixed(2)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
};
</script>
